module.exports = __webpack_public_path__ + "static/img/job-description-generator-icon.966799b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/job-description-generator-icon.png
// module id = VKV5
// module chunks = 0